<div mat-dialog-content>
    <div class="segment-container-button">
        <button mat-icon-button (click)="onClose()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>
    <app-genSegmentNew (closeDialog)="onClose()" [segmentId]="segmentId"></app-genSegmentNew>
</div>